import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const backgroundImage = isMobile
        ? "https://geneartai.com/images/mobile1.png"
        : "https://geneartai.com/images/image1.png";

    return (
        <div className="relative min-h-screen font-sans text-white overflow-x-hidden">

            {/* Responsive Background */}
            <div
                className="fixed inset-0 bg-cover bg-center z-0"
                style={{
                    backgroundImage: `url('${backgroundImage}')`,
                    backgroundAttachment: isMobile ? "scroll" : "fixed",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="absolute inset-0"></div>
            </div>

            {/* Foreground Content */}
            <div className="relative z-10 flex flex-col min-h-screen">

                {/* Top Spacer for Navbar */}
                <div className="pt-28" />

                {/* Main Content */}
                <div className="flex-grow p-6">
                    <div className="max-w-4xl mx-auto bg-black/50 text-white p-8 rounded-2xl shadow-2xl backdrop-blur-md">
                        <h1 className="text-3xl font-extrabold mb-6 text-center">
                            Privacy Policy
                        </h1>

                        <p className="mb-4">
                            Welcome to <strong>GeneArtAI</strong> ("we", "our", "us"). This Privacy Policy explains how we collect, use, and protect your information when you use our website at <strong>https://geneartai.com</strong>.
                        </p>

                        <h2 className="text-2xl font-bold mt-6 mb-2">Information We Collect</h2>
                        <p className="mb-4">
                            We collect basic user information when you create an account (such as email address, first name, last name). We also collect prompts you submit for generating AI images.
                        </p>

                        <h2 className="text-2xl font-bold mt-6 mb-2">Cookies</h2>
                        <p className="mb-4">
                            We use cookies to enhance your browsing experience and provide personalized services. Our cookie usage is managed by Cookiebot to comply with GDPR and ePrivacy laws.
                        </p>

                        <h2 className="text-2xl font-bold mt-6 mb-2">Third Party Services</h2>
                        <p className="mb-4">
                            We use third-party services such as Firebase (for authentication and data storage), Replicate API (for AI image generation), and Google AdSense (for displaying advertisements). These services may collect limited information as required by their own policies.
                        </p>

                        <h2 className="text-2xl font-bold mt-6 mb-2">User Rights (GDPR)</h2>
                        <p className="mb-4">
                            If you are a resident of the European Economic Area (EEA), the United Kingdom (UK), or Switzerland, you have rights under GDPR including the right to access, correct, or delete your personal information.
                        </p>

                        <h2 className="text-2xl font-bold mt-6 mb-2">Consent Management</h2>
                        <p className="mb-4">
                            Users in the EEA, UK, and Switzerland are presented with a consent banner managed by Cookiebot, allowing them to choose how their data is used for cookies and ads.
                        </p>

                        <h2 className="text-2xl font-bold mt-6 mb-2">Contact Us</h2>
                        <p className="mb-4">
                            If you have any questions or concerns about this Privacy Policy, please contact us at:
                            <br />
                            <strong>Email:</strong> support@geneartai.com
                        </p>

                        <p className="text-xs mt-8 text-center text-gray-400">
                            Last Updated: April 2025
                        </p>
                    </div>
                </div>

                {/* Footer */}
                <footer className="text-center text-xs text-gray-300 pb-3">
                    <div>© 2025 GeneArtAI — All Rights Reserved.</div>
                    <div className="mt-2">
                        <Link to="/privacy-policy" className="text-gray-300 hover:text-white underline">
                            Privacy Policy
                        </Link>{" "}
                        |{" "}
                        <Link to="/terms-of-service" className="underline hover:text-white">
                            Terms of Service
                        </Link>
                    </div>
                </footer>

                {/* Mobile Spacer */}
                <div className="block sm:hidden h-20" />
            </div>
        </div>
    );
}
